import { ethers } from "ethers";
import abi from "../SmartContract/abi.json";
import code from "../SmartContract/bytecode.json";

export const connectWallet = async () => {
  if (window.ethereum) {
    return window.ethereum
      .request({ method: "eth_requestAccounts" })
      .then((res) => {
        return res[0];
      });
  }
};

export const provider_Signer = async () => {
  // const provider = new ethers.BrowserProvider(window.ethereum);
  const provider = new ethers.JsonRpcProvider("HTTP://127.0.0.1:7545");

  const signer = await provider.getSigner();

  return { signer, provider };
};

export const getProvider = () => {
  // const provider = new ethers.BrowserProvider(window.ethereum);
  const provider = new ethers.JsonRpcProvider("HTTP://127.0.0.1:7545");

  return provider;
};

export const DeployContract = async (signer, provider, data) => {
  const factory = new ethers.ContractFactory(abi, code.bytecode, signer);
  const contract = await factory
    .deploy(data.title, "symbol", data.price, data.url, data.size)
    .then(async (res) => {
      await res.deploymentTransaction().wait();
      let add = res.getAddress();
      console.log(add);
      return add;
    });

  return contract;
};

export const SignUser = async () => {
  let actualMessage = "hello its signing test message";
  // const provider = new ethers.JsonRpcProvider("HTTP://127.0.0.1:7545");
  const provider = new ethers.BrowserProvider(window.ethereum)
  const signer = await provider.getSigner();
  const publicKey =await signer.getAddress()
  const signature = await signer.signMessage(actualMessage);
  console.log(signature)
  return {
    publicKey,
    actualMessage,
    signMessage:signature,
  };
};
